import styled from 'styled-components';

import { Header, HeaderTitle } from 'components/Header';
import { PageTitle } from 'components/PageTitle';

import { PAGES } from 'constants/pages';

import { PasswordSettings } from './components/PasswordSettings';
import { SenseiSettings } from './components/SenseiSettings';
import { ThemeSettings } from './components/ThemeSettings';

export const Settings = (): JSX.Element => {
    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.settings} />
                </HeaderTitle>
            </Header>
            <Content>
                <ScrollableContent>
                    <ThemeSettings />
                    <PasswordSettings />
                    <SenseiSettings />
                </ScrollableContent>
            </Content>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const Content = styled.div`
    flex: 1;
    overflow: hidden;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const ScrollableContent = styled.div`
    padding: 15px;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    max-width: 400px;

    & > :not(:first-child) {
        margin-top: 10px;
    }
`;
